$(function () {
    $('a[href^="#"]').click(function () {
        let speed = 800;
        let href = $(this).attr("href");
        let target = $(href == "#" || href == "" ? 'html' : href);
        let position = target.offset().top;
        $("html, body").animate({ scrollTop: position }, speed, "swing");
        return false;
    });
});

$(function () {
    $('.kb_header_menu').on('click', function () {
        $('.sp_nav').toggleClass('active');
        $('.modal_mask').fadeToggle(200);
        $('body').toggleClass('noscroll');
    });
    $('.sp_nav_close').on('click', function () {
        $('.sp_nav').removeClass('active');
        $('.modal_mask').fadeOut(200);
        $('body').removeClass('noscroll');
    });
});

$(function () {
    $('.sub_menu_open').on('click', function () {
      $(this).next().slideToggle(200);
      $(this).toggleClass("active");
    });
});

$(function () {
    $('.sub_menu_open_inner').on('click', function () {
      $(this).next().slideToggle(200);
      $(this).toggleClass("active");
    });
});

// 20250325 add
const pagetop_btn = document.querySelector(".pagetop");
pagetop_btn.addEventListener("click", scroll_top);
function scroll_top() {
  window.scroll({ top: 0, behavior: "smooth" });
}
window.addEventListener("scroll", scroll_event);
function scroll_event() {
  if (window.pageYOffset > 200) {
    pagetop_btn.style.opacity = "1";
  } else if (window.pageYOffset < 200) {
    pagetop_btn.style.opacity = "0";
  }
}
